import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Input,
  Button,
  Typography,
  DropDownMenu,
  Checkbox,
} from '@safedns/skydns-ui-react-lib';

import {
  useGetUserQuery,
  useCreateLocalDomainMutation,
  useGetDomainControllersQuery,
} from '../../services/ADapi';

import { validateLocalDomainName } from '../../utils/validateLocalDomainName';

import { notificationSuccess } from '../../store/notificationReducer';
import styles from './LocalDomainsForm.module.scss';

const LocalDomainsForm = () => {
  const dispatch = useDispatch();
  const [localDomainName, setLocalDomainName] = useState('');
  const [domainController, setDomainController] = useState([]);
  const [isLocalDomainsFormValid, setLocalDomainsFormState] = useState(false);
  const [errors, setErrors] = useState({});

  const {
    data: { user_id },
  } = useGetUserQuery();
  const { data: controllers = [] } = useGetDomainControllersQuery(user_id);
  const [createLocalDomain] = useCreateLocalDomainMutation();

  // TODO: Here we definitely need to wait until all entities are loaded
  useEffect(() => {
    setDomainController([controllers?.[0]]);
  }, [controllers]);

  useEffect(() => {
    const localDomainNameValid = validateLocalDomainName(localDomainName);

    setLocalDomainsFormState(localDomainNameValid);
  }, [localDomainName]);

  const localDomainNameHandler = (e) => {
    const errorsCopy = { ...errors };
    delete errorsCopy.domain;
    setErrors(errorsCopy);
    setLocalDomainName(e.target.value);
  };

  const handleControllerChange = (controller) => {
    setDomainController((prev) => {
      const isAlreadySelected = prev.some((c) => c?.id === controller.id);

      if (isAlreadySelected) {
        return prev.filter((c) => c?.id !== controller.id);
      } else {
        return [...prev, controller];
      }
    });
  };

  const createLocalDomainHandler = async () => {
    const ids = domainController.map((c) => c.id);

    try {
      await createLocalDomain({
        user_id,
        localDomain: {
          domain: localDomainName,
          controller_ids: ids,
        },
      }).unwrap();

      setLocalDomainName('');
      setDomainController([controllers[0]]);

      dispatch(
        notificationSuccess({
          isNotification: true,
          type: 'success',
          message: 'Локальный домен успешно создан',
        })
      );
    } catch (error) {
      setErrors(error);
      setLocalDomainsFormState(false);
    }
  };

  return (
    <>
      <div className={styles['form-container']}>
        <div className={styles['form-item']}>
          <Input
            id="localDomainName"
            label="Создание локального домена"
            placeholder="Введите полное имя домена"
            value={localDomainName}
            onChange={localDomainNameHandler}
          />
          {errors.domain ? (
            <Typography
              variant="body2"
              color="#e08d8d"
              className={styles['error-message']}
            >
              {errors.domain}
            </Typography>
          ) : null}
        </div>
        <div className={styles['form-item']}>
          <DropDownMenu
            id="selectDomainController"
            label="Выбрать домен контроллер"
            name={
              domainController
                ?.map((c) => c?.name)
                .filter(Boolean)
                .join(', ') || 'Не выбрано'
            }
          >
            {controllers.map((controller) => (
              <Checkbox
                key={controller.id}
                label={controller.name}
                isChecked={domainController?.some(
                  (c) => c?.id === controller.id
                )}
                onChange={() => handleControllerChange(controller)}
                sx={{ padding: 8 }}
              />
            ))}
          </DropDownMenu>
          {errors.controller_ids ? (
            <Typography
              variant="body2"
              color="#e08d8d"
              className={styles['error-message']}
            >
              {errors.controller_ids}
            </Typography>
          ) : null}
        </div>
        <div className={styles['form-item']}>
          <Button
            type="submit"
            variant="primary"
            isDisabled={
              !isLocalDomainsFormValid || domainController.length === 0
            }
            onClick={createLocalDomainHandler}
            className={styles['form-button']}
          >
            Создать локальный домен
          </Button>
        </div>
      </div>
      {errors.non_field_errors ? (
        <Typography variant="body2" color="#e08d8d">
          {errors.non_field_errors}
        </Typography>
      ) : null}
    </>
  );
};

export default LocalDomainsForm;
